'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AnnounceProvider: function() {
        return AnnounceProvider;
    },
    useAnnounce: function() {
        return useAnnounce;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
/**
 * @internal
 */ const AnnounceContext = _react.createContext(undefined);
const AnnounceProvider = AnnounceContext.Provider;
function useAnnounce() {
    var _React_useContext;
    return (_React_useContext = _react.useContext(AnnounceContext)) !== null && _React_useContext !== void 0 ? _React_useContext : {
        announce: ()=>undefined
    };
}
